module.exports = __webpack_public_path__ + "img/home.beea21db.jpg";